import { useState } from 'react';
import { Link } from 'react-router-dom';
import './ABComponent.css';

/* SVG Icons for Stats Bar */
const BarIcon = ({ type }) => {
  switch (type) {
    case 'ribbon':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <circle cx="12" cy="8" r="6" />
          <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
        </svg>
      );
    case 'globe':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>
      );
    case 'building':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <rect x="4" y="2" width="16" height="20" rx="2" />
          <path d="M8 6h3M8 10h3M8 14h3M8 18h3M15 6h1M15 10h1M15 14h1M15 18h1" />
        </svg>
      );
    case 'trust':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    default:
      return null;
  }
};

/* SVG Icons for Our Values */
const StrengthIcon = ({ type }) => {
  switch (type) {
    case 'integrity':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
      );
    case 'quality':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
      );
    case 'innovation':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-7 7c0 2.38 1.19 4.47 3 5.74V17a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.26c1.81-1.27 3-3.36 3-5.74a7 7 0 0 0-7-7z" />
        </svg>
      );
    case 'customer':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      );
    case 'ownership':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <path d="M20 12V8H6a2 2 0 0 1 0-4h12v4" />
          <path d="M4 6v12a2 2 0 0 0 2 2h14v-4" />
          <path d="M18 12a2 2 0 0 0 0 4h4v-4z" />
        </svg>
      );
    case 'improvement':
      return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="1.6">
          <polyline points="3 17 9 11 13 15 21 7" />
          <polyline points="14 7 21 7 21 14" />
        </svg>
      );
    default:
      return null;
  }
};

const ABComponent = () => {
  // Wraps every "1" character in its own span with a different font,
  // while the rest of the number keeps the Cormorant Garamond style.
  const renderNumberWithStyledOne = (str) =>
    str.split('').map((char, i) =>
      char === '1' ? (
        <span key={i} className="ab-one-digit">1</span>
      ) : (
        char
      )
    );

  const heroSlides = [
    '/Assets/AboutPage_Images/1.png',
    '/Assets/AboutPage_Images/2.png',
    '/Assets/AboutPage_Images/3.png',
  ];
  const [heroSlideIndex, setHeroSlideIndex] = useState(0);

  const goToPrevSlide = () => {
    setHeroSlideIndex((prev) => (prev === 0 ? heroSlides.length - 1 : prev - 1));
  };
  const goToNextSlide = () => {
    setHeroSlideIndex((prev) => (prev === heroSlides.length - 1 ? 0 : prev + 1));
  };

  const statsBar = [
    { type: 'ribbon', number: '16+', label: 'Types of Blinds' },
    { type: 'globe', number: '2,000+', label: 'Shades of Fabrics' },
    { type: 'building', number: '10+', label: 'Operating Systems' },
    { type: 'trust', number: '25+', label: 'Years of Experience' },
  ];

  const ourValues = [
    {
      id: 'integrity',
      title: 'Our Commitment',
      desc: 'We deal with commitment and integrity, being honest, reasonable and transparent to everyone associated with us.'
    },
    {
      id: 'customer',
      title: 'Customer Service Focus',
      desc: 'We ensure the desired level of quality for our customers, with continued availability of product with right quality at right time.'
    },
    {
      id: 'quality',
      title: 'Excellence & Quality',
      desc: 'We focus on innovation, outstanding service, and operational excellence for our clients, providing the best customer service in the industry.'
    },
    {
      id: 'innovation',
      title: 'Pioneering Innovation',
      desc: 'We will be strong and agile, courageously taking on challenges, using in-depth customer insight to develop innovative solutions.'
    },
    {
      id: 'ownership',
      title: 'Ownership and Responsibility',
      desc: 'We strive to continuously rejuvenate every living and working space of people and bring joy to their lives.'
    },
    {
      id: 'improvement',
      title: 'People',
      desc: 'We strongly believe in individual ability and creating an environment in which the entrepreneurial spirit is encouraged within the team.'
    },
  ];

  return (
    <div className="ab-root">

      {/* ── 1. Hero Section — About Us Intro ── */}
      <section className="ab-hero-v4">
        <div className="ab-container">
          <div className="ab-hero-v4-grid">

            <div className="ab-hero-v4-left">
              <span className="ab-eyebrow">ABOUT US</span>
              <h1 className="ab-hero-v4-title">
                Why <span className="ab-gold-text">Marvel</span>
              </h1>
              <div className="ab-hero-v4-narrative">
                <p>
                  Marvel is a multinational brand which is supported by entrepreneurs with vast
                  experience in various countries for more than 25 years in the window covering
                  industry. Marvel Window Fashions has carved a niche by combining innovation,
                  research, quality, technology and experience giving birth to the largest range
                  of blinds in the world.
                </p>
                <p style={{ marginTop: '16px' }}>
                  Being the most innovative, quality oriented and determined to give unparalleled
                  service is our motto. The genesis of our blinds with inceptive research and
                  innovative ideas from a customer-centric solution-based outlook and strong
                  establishment of brand values makes us stand out as leaders.
                </p>
              </div>

              <ul className="ab-check-list ab-hero-check-list">
                <li><span className="chk">✓</span> World's largest range of 16 types of blinds</li>
                <li><span className="chk">✓</span> Multiple operating systems to match every need</li>
                <li><span className="chk">✓</span> 2,000+ shades of fabrics for the best interiors</li>
              </ul>
            </div>

            <div className="ab-hero-v4-right">
              <div className="ab-hero-photo-card">
                <img
                  src={heroSlides[heroSlideIndex]}
                  alt="Marvel window solutions"
                  className="ab-hero-photo-img"
                />

                <button
                  className="ab-hero-slider-arrow ab-hero-slider-arrow-left"
                  onClick={goToPrevSlide}
                  aria-label="Previous slide"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="15 18 9 12 15 6" />
                  </svg>
                </button>
                <button
                  className="ab-hero-slider-arrow ab-hero-slider-arrow-right"
                  onClick={goToNextSlide}
                  aria-label="Next slide"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="9 18 15 12 9 6" />
                  </svg>
                </button>

                <div className="ab-hero-slider-dots">
                  {heroSlides.map((_, i) => (
                    <span
                      key={i}
                      className={`ab-hero-slider-dot ${i === heroSlideIndex ? 'active' : ''}`}
                      onClick={() => setHeroSlideIndex(i)}
                    />
                  ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── 2. Stats Bar ── */}
      <section className="ab-stats-bar-section">
        <div className="ab-container">
          <div className="ab-stats-bar">
            {statsBar.map((st, i) => (
              <div key={i} className="ab-bar-item">
                <div className="ab-bar-icon">
                  <BarIcon type={st.type} />
                </div>
                <div className="ab-bar-info">
                  <span className="ab-bar-num">{renderNumberWithStyledOne(st.number)}</span>
                  <span className="ab-bar-label">{st.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── 3. Our Unique Culture (mirrored hero-style: image left, text right) ── */}
      <section className="ab-section ab-culture-section">
        <div className="ab-container">
          <div className="ab-culture-grid">

            <div className="ab-culture-image-wrapper">
              <img
                src="/Assets/AboutPage_Images/A3.webp"
                alt="Our Unique Culture"
                className="ab-culture-img"
              />
            </div>

            <div className="ab-culture-content">
              <span className="ab-eyebrow">OUR UNIQUE CULTURE</span>
              <h2 className="ab-section-title">Growth is Life</h2>
              <p className="ab-company-v3-desc">
                We strive to create a culture that reinforces our values for everyone associated
                with us, improving the quality of life of the society and community at large,
                with major focus on value creation based on leadership with trust.
              </p>
              <ul className="ab-check-list">
                <li><span className="chk">✓</span> Enhancing satisfaction of team members and communities</li>
                <li><span className="chk">✓</span> Progressing towards sustainability in every solution</li>
                <li><span className="chk">✓</span> Embracing change and reducing friction across the company</li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      {/* ── 4. Our Vision + Our Mission (stacked left, shared image right) ── */}
      <section className="ab-section ab-presence-v3-section">
        <div className="ab-container">
          <div className="ab-presence-grid">

            <div className="ab-presence-left">

              <div className="ab-vision-mission-block">
                <span className="ab-eyebrow">OUR VISION</span>
                <p className="ab-project-exp-text ab-vm-text">
                  To Emerge as the foremost Global Brand, we aim to redefine living environments
                  with innovative window covering solutions, and making a great impact across the
                  Globe.
                </p>
              </div>

              <div className="ab-vision-mission-block">
                <span className="ab-eyebrow">OUR MISSION</span>
                <p className="ab-project-exp-text ab-vm-text">
                  By 2030, we endeavor to make significant progress towards realizing our vision
                  by seizing opportunities for exponential growth through continuous innovation,
                  expanding our global footprint, ensuring unparalleled customer satisfaction, and
                  fostering enduring trust with every stakeholder.
                </p>
              </div>

              <Link to="/products" className="ab-presence-btn">
                EXPLORE OUR PRODUCTS
              </Link>
            </div>

            <div className="ab-presence-right">
              <div className="ab-presence-map-card">
                <img
                  src="/Assets/AboutPage_Images/A4.webp"
                  alt="Marvel vision and mission for the future of window solutions"
                  className="ab-presence-map-img"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── 5. Innovative Window Styling ── */}
      <section className="ab-section ab-project-exp-section">
        <div className="ab-container">
          <div className="ab-project-exp-box">
            <span className="ab-eyebrow">INNOVATIVE WINDOW STYLING</span>
            <p className="ab-project-exp-text">
              For the past 25 years we've made it our passion to understand the many elements of
              light. From making a cloudy day seem brighter or helping a hot room feel cooler and
              more comfortable, we seek to understand your place and its relationship to daylight.
              That is what makes us different — our attention to detail with every product that we
              present. That is what makes our window coverings an everyday luxury.
            </p>
          </div>
        </div>
      </section>

      {/* ── 6. Our Values ── */}
      <section className="ab-section ab-strengths-v3-section">
        <div className="ab-container">

          <div className="ab-section-header center">
            <span className="ab-eyebrow">OUR VALUES</span>
            <h2 className="ab-section-title center">
              The Principles Behind Everything We Create
            </h2>
          </div>

          <div className="ab-strengths-v3-grid">
            {ourValues.map((val) => (
              <div key={val.id} className="ab-strength-v3-card">
                <div className="ab-strength-v3-icon">
                  <StrengthIcon type={val.id} />
                </div>
                <h3 className="ab-strength-v3-title">{val.title}</h3>
                <p className="ab-strength-v3-desc">{val.desc}</p>
              </div>
            ))}
          </div>

        </div>
      </section>

    </div>
  );
};

export default ABComponent;